import type { WorkOrderDocumentViewModel } from '@api/enterprise/openapi';
import { WorkOrderDocumentType } from '@api/enterprise/openapi';
import {
  SIGNATURE_DOCUMENT,
  SIGNATURE_MODE
} from '../constants/signatureDocumentConstants';

export type SignatureMode =
  (typeof SIGNATURE_MODE)[keyof typeof SIGNATURE_MODE];

export type ParsedSignatureData = {
  mode: SignatureMode;
  name: string;
};

const STORAGE_TO_RUNTIME: Record<string, SignatureMode> = {
  DRAW: SIGNATURE_MODE.DRAW,
  TYPE: SIGNATURE_MODE.TYPE
};

export const findSignatureDocument = (
  documents: WorkOrderDocumentViewModel[] | undefined
): WorkOrderDocumentViewModel | undefined => {
  return documents?.find(
    doc =>
      (doc.documentCompany === SIGNATURE_DOCUMENT.COMPANY ||
        doc.documentCompany === 'ATTACH') &&
      doc.documentName === SIGNATURE_DOCUMENT.NAME &&
      doc.documentType === WorkOrderDocumentType.CustomerSignature
  );
};

export const parseSignatureData = (
  signatureText: string
): ParsedSignatureData => {
  const [mode, name] = signatureText.split(':');
  return {
    mode: STORAGE_TO_RUNTIME[mode] || SIGNATURE_MODE.DRAW,
    name: name || ''
  };
};

export const formatSignatureText = (
  mode: SignatureMode,
  printedName: string
): string => {
  return `${mode.toUpperCase()}:${printedName.trim()}`;
};
